import { render, staticRenderFns } from "./ApprovedScientificTopics.vue?vue&type=template&id=084a2cea&scoped=true&"
import script from "./ApprovedScientificTopics.vue?vue&type=script&lang=js&"
export * from "./ApprovedScientificTopics.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedScientificTopics.vue?vue&type=style&index=0&id=084a2cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a2cea",
  null
  
)

export default component.exports